const ErrorPage = () => {
  return (
    <div>
      ERROR ALERT
    </div>
  )
};

export default ErrorPage;